import React from "react";
import styled from "styled-components";

//
import DOCTORLIST from "../../../assets/data/doctor-list";
import DoctorCard from "../../../components/doctor-card/DoctorCard";

export default function DoctorsList() {
  return (
    <StyledDoctorsList>
      <div className="container">
        <div className="doctor-list__wrap">
          <ul className="doctor-list__list">
            {DOCTORLIST.map((i) => (
              <li key={i.id}>
                <DoctorCard
                  id={i.id}
                  img={i.img}
                  imagePosition={i.imagePosition}
                  imageScale={i.imageScale}
                  name={i.name}
                  spec={i.specialist}
                  socials={i.socials}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
    </StyledDoctorsList>
  );
}

const StyledDoctorsList = styled.section`
  background-color: var(--white);
  padding: 100px 0;

  .doctor-list {
    &__list {
      display: grid;
      grid-template-columns: repeat(3, minmax(0, 1fr));
      gap: 72px 48px;
      align-items: start;
    }

    &__list > li {
      min-width: 0;
      height: 100%;
    }
  }

  @media (max-width: 992px) {
    .doctor-list {
      &__list {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        gap: 56px 32px;
      }
    }
  }

  @media (max-width: 640px) {
    padding: 70px 0;

    .doctor-list {
      &__list {
        grid-template-columns: 1fr;
        gap: 48px;
      }
    }
  }
`;
